@if (media) {
  @if (media.mime.startsWith('image')) {
    <img
      [src]="media.url | prependBaseUrl"
      [alt]="media.alternativeText"
      draggable="false"
    />
  } @else {
    <video [src]="media.url | prependBaseUrl" [muted]="true" [autoplay]="true" playsInline loop onloadedmetadata="this.muted=true">
      <meta itemprop="description" [content]="media.alternativeText" />
    </video>
  }
}
